<template>
  <page>
    <template slot="content">
    <help-content :title="'WeBandの睡眠や歩数がアプリに反映されない'">
      <template slot="content">
        <div class="text">
          <b>ペアリングが切れた場合</b>の回答にしたがって操作してください。<br>
        </div>
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help19.vue